import React from 'react'
import z from 'zod'
import { ProductType } from '@reward-platform/ancillaries-schemas/common'
import { HotelSearchParamsSchema } from '@reward-platform/ancillaries-schemas/hotel'
import { CarHireSearchFormParamsSchema } from '@reward-platform/ancillaries-schemas/car-hire'
import { ExperienceSearchParamsSchema } from '@reward-platform/ancillaries-schemas/experience'

export type FilterList = Array<Filter> | undefined

export interface FiltersProps {
  filters: FilterList
  values: Record<string, string | string[]>
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleApplyFiltersClick: () => void
  handleResetClick: () => void
  /** used for dirty state */
  activeFilters: FilterType
  productType: ProductType
}

export interface FilterGroupProps {
  group: Filter
  onChange: FiltersProps['onChange']
  values: FiltersProps['values']
  productType: ProductType
}

export type FilterType = Record<string, string | string[]>

export interface Filter {
  key: string
  title: string
  type?: 'multi' | 'single' | 'range'
  options?: FilterOptions[]
  rangeOptions?: {
    startValue?: number
    endValue?: number
    minValue?: number
    maxValue?: number
  }
}

interface FilterOptions {
  name: string
  key: string
}

export type FilterRenderProps = {
  filter: Filter
  value?: string | string[]
  onChange: FiltersProps['onChange']
}

export type SortBy = {
  sortBy?: 'RECOMMENDED' | 'PRICE' | 'STAR_RATING'
  orderBy?: 'ASC' | 'DESC'
}

export interface SortOption {
  label: string
  value: string
  disabled?: boolean
}

export const ProductFiltersQueriesSchema = {
  HOTEL: HotelSearchParamsSchema.pick({ shoppingFilter: true, sorting: true }),
  CAR_HIRE: CarHireSearchFormParamsSchema.pick({ shoppingFilter: true, sorting: true }),
  EXPERIENCE: ExperienceSearchParamsSchema.pick({ shoppingFilter: true, sorting: true }),
} as const

export type ProductFilterQueries<T extends ProductType> = z.infer<
  (typeof ProductFiltersQueriesSchema)[T]
>
